import React from 'react';
import './PrivacyPolicy.css';

export default function PrivacyPolicyFR() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy__hero">
        <div className="container">
          <h1>Politique de confidentialité</h1>
          <p className="privacy-policy__date">Date d'entrée en vigueur : 1er décembre 2024</p>
        </div>
      </div>

      <div className="container privacy-policy__content">
        <div className="privacy-policy__contact-box">
          <h3>Responsable de la protection des renseignements personnels</h3>
          <p><strong>Christophe Lavoie</strong></p>
          <p>Courriel : <a href="mailto:privacy@vision-security.ca">privacy@vision-security.ca</a></p>
          <p>Téléphone : <a href="tel:+15142797209">(514) 279-7209</a></p>
          <p>Adresse : 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
          <p className="privacy-policy__response-time">Nous répondons à toutes les demandes dans les 30 jours suivant leur réception.</p>
        </div>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Vision Sécurité Inc. (« Vision Sécurité », « nous », « notre » ou « nos ») s'engage à protéger la vie privée 
            et les renseignements personnels de ses clients, visiteurs de site Web, employés et partenaires d'affaires. 
            La présente Politique de confidentialité explique comment nous recueillons, utilisons, communiquons, conservons 
            et protégeons les renseignements personnels conformément à la <strong>Loi sur la protection des renseignements 
            personnels dans le secteur privé du Québec</strong> (telle que modifiée par la Loi 25) et à la <strong>Loi sur 
            la protection des renseignements personnels et les documents électroniques (LPRPDE)</strong> du Canada.
          </p>
          <p>
            Cette Politique s'applique à tous les renseignements personnels traités par l'intermédiaire de nos sites Web, 
            services de sécurité, opérations commerciales et interactions hors ligne.
          </p>
        </section>

        <section>
          <h2>2. Renseignements personnels que nous recueillons</h2>
          <p>
            Nous recueillons uniquement les renseignements personnels nécessaires pour fournir des services de sécurité 
            professionnels. Les types d'informations incluent :
          </p>
          
          <h3>Informations d'identité et de contact</h3>
          <p>Noms, titres, adresses, numéros de téléphone et courriels des clients, employés, candidats et partenaires.</p>

          <h3>Données clients et services</h3>
          <p>Détails spécifiques aux sites tels que plans des locaux, codes d'accès, contacts d'urgence et procédures opérationnelles.</p>

          <h3>Données opérationnelles</h3>
          <p>Journaux de patrouille, rapports d'incidents, enregistrements vidéo, registres de contrôle d'accès et journaux de visiteurs.</p>

          <h3>Informations RH</h3>
          <p>CV, licences BSP, horaires, évaluations, formations, paie et vérifications d'antécédents.</p>

          <h3>Données techniques</h3>
          <p>Adresses IP, type d'appareil, pages consultées, sources de référence et préférences de cookies.</p>
        </section>

        <section>
          <h2>3. Comment nous recueillons les renseignements</h2>
          <ul>
            <li><strong>Interactions directes :</strong> Formulaires, contrats, communications par courriel/téléphone, rencontres en personne et candidatures.</li>
            <li><strong>Activités de service :</strong> Patrouilles, réponse aux incidents, surveillance vidéo et contrôle d'accès.</li>
            <li><strong>Sources tierces :</strong> Clients commerciaux, sources publiques et organismes gouvernementaux comme le BSP.</li>
            <li><strong>Technologies automatisées :</strong> Cookies et technologies de suivi sur notre site Web.</li>
            <li><strong>Fournisseurs de services :</strong> Agences de vérification, processeurs de paie et fournisseurs informatiques.</li>
          </ul>
        </section>

        <section>
          <h2>4. Objectifs et bases légales</h2>
          <ul>
            <li><strong>Prestation de services :</strong> Évaluations de sécurité, gestion du personnel, patrouilles, réponse aux urgences, rapports et facturation.</li>
            <li><strong>Conformité légale :</strong> Licences, normes d'emploi, déclarations fiscales, santé et sécurité, et réponses aux autorités.</li>
            <li><strong>Opérations commerciales :</strong> Assurance qualité, formation, planification, comptabilité, cybersécurité et continuité.</li>
            <li><strong>Marketing :</strong> Développement commercial, propositions et communications marketing avec votre consentement.</li>
            <li><strong>Intérêts vitaux :</strong> Protection des personnes en situations d'urgence.</li>
          </ul>
        </section>

        <section>
          <h2>5. Consentement</h2>
          <p>Nous obtenons un consentement libre, éclairé et spécifique pour les communications marketing, les cookies non essentiels et certaines divulgations.</p>
          
          <h3>Retrait du consentement</h3>
          <p>Vous pouvez retirer votre consentement à tout moment en contactant notre Responsable. Le retrait peut affecter certains services.</p>

          <h3>Mineurs</h3>
          <p>Nous ne recueillons pas sciemment de renseignements auprès d'enfants de moins de 14 ans sans consentement parental.</p>
        </section>

        <section>
          <h2>6. Partage et divulgation</h2>
          <p><strong>Nous ne vendons jamais de renseignements personnels.</strong> Nous pouvons partager avec :</p>
          <ul>
            <li><strong>Fournisseurs de services :</strong> Fournisseurs informatiques, agences de vérification, processeurs de paie, sous engagement de confidentialité.</li>
            <li><strong>Conseillers professionnels :</strong> Avocats, comptables et assureurs.</li>
            <li><strong>Autorités :</strong> Police, BSP, Commission d'accès à l'information, tribunaux, lorsque requis par la loi.</li>
            <li><strong>Transactions corporatives :</strong> Lors de fusions ou acquisitions, avec garanties appropriées.</li>
          </ul>
        </section>

        <section>
          <h2>7. Vos droits</h2>
          <div className="rights-grid">
            <div className="right-item">
              <h3>Droit d'accès</h3>
              <p>Demandez des copies de vos renseignements personnels. Réponse sous 30 jours.</p>
            </div>
            <div className="right-item">
              <h3>Droit de rectification</h3>
              <p>Demandez la correction d'informations inexactes ou incomplètes.</p>
            </div>
            <div className="right-item">
              <h3>Droit à l'effacement</h3>
              <p>Demandez la suppression de vos données après les obligations légales.</p>
            </div>
            <div className="right-item">
              <h3>Portabilité</h3>
              <p>Recevez vos données dans un format lisible par machine.</p>
            </div>
            <div className="right-item">
              <h3>Opposition</h3>
              <p>Objectez au traitement, particulièrement pour le marketing direct.</p>
            </div>
            <div className="right-item">
              <h3>Déréférencement</h3>
              <p>La Loi 25 prévoit le droit de demander le déréférencement d'informations désuètes.</p>
            </div>
          </div>
          
          <div className="exercise-rights-box">
            <h3>Exercice des droits</h3>
            <p>
              Contactez <a href="mailto:privacy@vision-security.ca">privacy@vision-security.ca</a> ou 
              <a href="tel:+15142797209"> (514) 279-7209</a> pour exercer vos droits. 
              Nous répondrons dans les 30 jours suivant la réception de votre demande.
            </p>
          </div>
        </section>

        <section>
          <h2>8. Mesures de sécurité</h2>
          <h3>Techniques</h3>
          <p>
            Chiffrement des données, authentification multifacteur, contrôles d'accès basés sur les rôles, mises à jour 
            de sécurité, détection d'intrusion et sauvegardes sécurisées.
          </p>

          <h3>Administratives</h3>
          <p>
            Permissions par rôle, accords de confidentialité, formation sur la vie privée, évaluations des fournisseurs 
            et plans de réponse aux incidents.
          </p>

          <h3>Physiques</h3>
          <p>Installations sécurisées, stockage verrouillé, destruction sécurisée des documents et accès restreint.</p>

          <div className="security-disclaimer">
            <h3>Limitation</h3>
            <p>
              Aucun système n'est totalement sécurisé. Nous nous engageons à remédier rapidement aux vulnérabilités et 
              à notifier les personnes concernées de toute violation pouvant causer un préjudice sérieux.
            </p>
          </div>
        </section>

        <section>
          <h2>9. Conservation et destruction</h2>
          <div className="retention-table">
            <div className="retention-row">
              <div className="retention-type"><strong>Dossiers clients</strong></div>
              <div className="retention-period">7 ans après la fin du contrat</div>
            </div>
            <div className="retention-row">
              <div className="retention-type"><strong>Rapports de sécurité</strong></div>
              <div className="retention-period">Jusqu'à 10 ans pour réclamations et procédures</div>
            </div>
            <div className="retention-row">
              <div className="retention-type"><strong>Dossiers RH</strong></div>
              <div className="retention-period">7 ans après la fin de l'emploi</div>
            </div>
            <div className="retention-row">
              <div className="retention-type"><strong>Données analytiques</strong></div>
              <div className="retention-period">Jusqu'à 26 mois</div>
            </div>
          </div>
          <h3>Destruction sécurisée</h3>
          <p>Déchiquetage croisé, effacement certifié et anonymisation.</p>
        </section>

        <section>
          <h2>10. Cookies et suivi</h2>
          
          <div className="cookie-notice-banner">
            <h3>⚠️ Avis important</h3>
            <p>
              Notre bannière de consentement aux cookies n'est actuellement pas fonctionnelle. Nous travaillons 
              activement à résoudre ce problème. En attendant, vous pouvez gérer vos préférences de cookies 
              directement dans les paramètres de votre navigateur.
            </p>
          </div>

          <h3>Cookies essentiels</h3>
          <p>Nécessaires pour la navigation et la sécurité. Ne peuvent être désactivés.</p>

          <h3>Cookies d'analytique</h3>
          <p>Avec consentement, pour comprendre l'utilisation du site et améliorer les performances.</p>

          <h3>Cookies marketing</h3>
          <p>Requièrent consentement explicite pour publicités personnalisées.</p>

          <h3>Gestion</h3>
          <p>
            Via les paramètres de votre navigateur jusqu'à ce que notre bannière de cookies soit réparée. 
            Veuillez noter que la désactivation de certains cookies peut limiter les fonctionnalités du site.
          </p>

          <h3>Cookies tiers</h3>
          <p>Consultez les politiques des tiers pour leurs pratiques.</p>
        </section>

        <section>
          <h2>11. Transferts internationaux</h2>
          <p>
            Vision Sécurité opère principalement au Québec et au Canada. Certains fournisseurs peuvent traiter des données 
            à l'extérieur.
          </p>
          <p>
            Nous mettons en œuvre des garanties appropriées : clauses contractuelles standard, accords de traitement des 
            données, évaluations d'impact et surveillance continue.
          </p>
          <p>Nous demeurons responsables des renseignements confiés aux fournisseurs.</p>
        </section>

        <section>
          <h2>12. Incidents de confidentialité</h2>
          <p>Nous tenons un registre des incidents et effectuons des évaluations des risques.</p>
          
          <h3>Réponse aux violations</h3>
          <ul>
            <li>Notification à la Commission d'accès à l'information du Québec</li>
            <li>Notification directe aux personnes concernées sans délai</li>
            <li>Mesures de confinement et de remédiation immédiates</li>
            <li>Examen post-incident et mesures correctives</li>
          </ul>
          <p><strong>Votre droit :</strong> Vous serez informé de toute violation pouvant causer un préjudice sérieux.</p>
        </section>

        <section>
          <h2>13. Confidentialité des enfants</h2>
          <p>
            Nous ne recueillons pas sciemment de renseignements auprès d'enfants de moins de 14 ans sans consentement 
            parental.
          </p>
          <p>
            Si nous découvrons une collecte inappropriée, nous supprimerons rapidement les informations. Contactez-nous 
            immédiatement si vous avez des préoccupations.
          </p>
        </section>

        <section>
          <h2>14. Transparence et évaluations</h2>
          <p>
            Nous effectuons des Évaluations de l'impact sur la vie privée (ÉVP) pour les nouveaux systèmes affectant 
            le traitement des renseignements personnels.
          </p>
          <p>
            Nos ÉVP évaluent : sensibilité des données, objectifs légaux, quantité de données, sécurité, risques pour 
            la vie privée et stratégies d'atténuation.
          </p>
        </section>

        <section>
          <h2>15. Modifications de la Politique</h2>
          <p>
            Nous pouvons mettre à jour cette Politique périodiquement. La date de « Dernière mise à jour » sera modifiée.
          </p>
          <p>
            <strong>Avis des changements importants :</strong> Annonces sur le site Web, communications directes par 
            courriel ou autres moyens appropriés.
          </p>
          <p>
            <strong>Votre responsabilité :</strong> Consultez périodiquement cette Politique. L'utilisation continue 
            constitue l'acceptation.
          </p>
        </section>

        <section>
          <h2>16. Coordonnées et plaintes</h2>
          
          <div className="contact-details-box">
            <p><strong>Responsable de la protection :</strong> Christophe Lavoie</p>
            <p><strong>Courriel :</strong> <a href="mailto:privacy@vision-security.ca">privacy@vision-security.ca</a></p>
            <p><strong>Téléphone :</strong> <a href="tel:+15142797209">(514) 279-7209</a></p>
            <p><strong>Adresse :</strong> 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
            <p className="response-time"><strong>Délai de réponse :</strong> 30 jours.</p>
          </div>

          <h3>Autorités de réglementation</h3>
          <p>
            Si vous n'êtes pas satisfait de notre réponse, vous pouvez déposer une plainte auprès des autorités de 
            réglementation :
          </p>

          <div className="regulatory-boxes">
            <div className="regulatory-box">
              <h4>Questions québécoises</h4>
              <p><strong>Commission d'accès à l'information du Québec</strong></p>
              <p>Site Web : <a href="https://www.cai.gouv.qc.ca" target="_blank" rel="noopener noreferrer">www.cai.gouv.qc.ca</a></p>
              <p>Téléphone : <a href="tel:+18885287741">1-888-528-7741</a></p>
            </div>

            <div className="regulatory-box">
              <h4>Questions fédérales</h4>
              <p><strong>Commissariat à la protection de la vie privée du Canada</strong></p>
              <p>Site Web : <a href="https://www.priv.gc.ca" target="_blank" rel="noopener noreferrer">www.priv.gc.ca</a></p>
              <p>Téléphone : <a href="tel:+18002821376">1-800-282-1376</a></p>
            </div>
          </div>

          <p className="regulatory-note">
            Ces organismes peuvent enquêter de manière indépendante et disposent de pouvoirs d'application incluant 
            ordonnances et pénalités.
          </p>
        </section>
      </div>
    </div>
  );
}
